import { setRefinersVisibility } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';
import {
    lazySetIsSuggestionsDropdownVisible,
    getScenarioStore,
    SearchScenarioId,
} from 'owa-search';

orchestrator(setRefinersVisibility, async actionMessage => {
    /**
     * If search refiners callout is being shown and suggestions dropdown
     * is being shown, hide suggestions dropdown.
     */
    if (
        actionMessage.isVisible &&
        getScenarioStore(SearchScenarioId.Mail).isSuggestionsDropdownVisible
    ) {
        const setIsSuggestionsDropdownVisible = await lazySetIsSuggestionsDropdownVisible.import();
        setIsSuggestionsDropdownVisible(false, SearchScenarioId.Mail);
    }
});
